import DynamicField from "./DynamicField.component";

const getField = (props) => (props ? <DynamicField fieldProps={props} /> : null);

export default getField;
